import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useCases } from '@/hooks';
import { resolvedCases } from '../filterCases';
import { useCaseTarget } from '../useCaseTarget';
import { CategoryBadge } from '../components/CategoryBadge';
import { StatusPill } from '../components/StatusPill';
import type { CaseRecord } from '@/core/models/case';

const Entry = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.color.glassBorder};
`;
const Head = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;
const HeadLink = styled(Link)`
  color: ${({ theme }) => theme.color.textPrimary};
  font-weight: 600;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
const Expl = styled.div`
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;
const Time = styled.span`
  margin-left: auto;
  font-size: ${({ theme }) => theme.fontSize.xs};
  color: ${({ theme }) => theme.color.textMuted};
`;
const Empty = styled.p`
  color: ${({ theme }) => theme.color.textMuted};
  padding: 24px 0;
`;

function AuditEntry({ c }: { c: CaseRecord }) {
  const t = useCaseTarget(c);
  return (
    <Entry>
      <Head>
        <CategoryBadge category={c.category} />
        <StatusPill status={c.status} />
        {t.href ? <HeadLink to={t.href}>{t.headline}</HeadLink> : <span>{t.headline}</span>}
        <Time>{c.time}</Time>
      </Head>
      {c.decision && <Expl>{c.decision.explanation}</Expl>}
      {c.appeal && <Expl>{c.appeal.explanation}</Expl>}
    </Entry>
  );
}

export function AuditLogSection() {
  const { cases } = useCases();
  const resolved = resolvedCases(cases);
  if (resolved.length === 0) return <Empty>No resolved decisions yet.</Empty>;
  return <div>{resolved.map((c) => <AuditEntry key={c.id} c={c} />)}</div>;
}
